module.exports = __webpack_public_path__ + "media/images/top/rank1-67b3bc845d96330d6a04312b8578320b.gif";